import { useCallback } from 'react';

const STATE_REFRESH_KEY = 'survey_state_last_update';

export const useCommitmentStateRefresh = () => {
  const updateLastRefresh = useCallback(() => {
    // Generate a random number to track state changes
    const randomId = Math.random();
    localStorage.setItem(STATE_REFRESH_KEY, randomId.toString());
  }, []);

  const getLastRefresh = useCallback(() => {
    const stored = localStorage.getItem(STATE_REFRESH_KEY);
    return stored || '0';
  }, []);

  const shouldRefresh = useCallback(
    (lastKnownUpdate: string): boolean => {
      const lastRefresh = getLastRefresh();
      // Compare for inequality since random numbers don't have chronological order
      return lastRefresh !== lastKnownUpdate;
    },
    [getLastRefresh]
  );

  return {
    updateLastRefresh,
    getLastRefresh,
    shouldRefresh,
  };
};
